import React, {FC} from "react";
import {InputNumber, Space} from "antd";
import type {InputNumberProps} from "antd";

// Percentage field (VAT, PPO): 0–100 with a themed "%" add-on, full width.
export const PercentInput: FC<InputNumberProps> = props => (
    <Space.Compact block>
        <InputNumber {...props} min={0} max={100} precision={4} style={{width: "100%", ...props.style}}/>
        <Space.Addon>%</Space.Addon>
    </Space.Compact>
);
